import parent from '../../path';

export const product = `${parent}/product`;

export const newProduct = `${parent}/product/new`;

export const matchProduct = `${parent}/product/:id`;

export default product;
